module.exports = __webpack_public_path__ + "media/media/logos/usaa-06b65c02504386e68a6cc5b9e7ffdb44.png";